import * as types from 'modules/checklists/actionTypes';
import type { DisplayDuplicateModalAction } from 'modules/checklists/types';
import { createReducer } from 'utils/ReduxUtils';

export type ChecklistDuplicateChecklistIdReducer = string | null;

const initialState: ChecklistDuplicateChecklistIdReducer = null;

const open = (
  _: ChecklistDuplicateChecklistIdReducer,
  { payload: checklistId }: DisplayDuplicateModalAction
): ChecklistDuplicateChecklistIdReducer => checklistId;

const close = (): ChecklistDuplicateChecklistIdReducer => null;

export default createReducer(initialState, {
  [types.DISPLAY_CHECKLIST_DUPLICATE_MODAL]: open,
  [types.HIDE_CHECKLIST_DUPLICATE_MODAL]: close,
});
